import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { CalendarBootstrapComponent } from './calendar/componentes/calendar-bootstrap/calendar-bootstrap.component';

const routes: Routes = [
  {
    path: "",
    component: CalendarBootstrapComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
